"use strict";

exports.__esModule = true;
exports.GridElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Device = require("../../Device");
var _common = require("../common");
var _gridUtils = require("./gridUtils");
var _dec, _class, _GridElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays an editable grid.
 */
var GridElement = exports.GridElement = (_dec = _Device.DeviceContext.withContext, _dec(_class = (_GridElement = /*#__PURE__*/function (_Component) {
  function GridElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(GridElement, _Component);
  var _proto = GridElement.prototype;
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      position = _this$props.position,
      children = _this$props.children,
      device = _this$props.device,
      testid = _this$props.testid;
    var colorProps = (0, _common.getWidgetColorProps)(this.props);
    if (device != null && colorProps.backgroundColorSource != null) {
      return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
        deviceUuid: device.uuid
      }, colorProps), function (_ref) {
        var backgroundColor = _ref.backgroundColor;
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          "data-testid": testid,
          style: {
            position: position,
            backgroundColor: backgroundColor,
            width: width,
            height: height,
            color: backgroundColor ? "#000" : "#fff"
          }
        }, (0, _common.getWidgetInteractionProps)(_this.props)), (children || []).map(function (child, index) {
          return _this.renderChild(child, index);
        }));
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      "data-testid": testid
    }, (0, _common.getWidgetInteractionProps)(this.props), {
      style: {
        height: height,
        width: width,
        position: position
      }
    }), (children || []).map(function (child, index) {
      return _this.renderChild(child, index);
    }));
  };
  _proto.renderChild = function renderChild(child, index) {
    var render = this.props.render;
    var _getGridCellDimension = (0, _gridUtils.getGridCellDimensions)(this.props, child.props),
      x = _getGridCellDimension.x,
      y = _getGridCellDimension.y,
      width = _getGridCellDimension.width,
      height = _getGridCellDimension.height;
    var style = {
      position: "absolute",
      left: x,
      top: y,
      width: width,
      height: height
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: String(index),
      style: style
    }, render(Object.assign({}, child, {
      props: Object.assign({}, child.props, {
        x: 0,
        y: 0,
        width: width,
        height: height
      })
    }), index));
  };
  return GridElement;
}(_react.Component), _GridElement.defaultProps = {
  testid: "GridElement",
  padding: 0
}, _GridElement)) || _class);